module.exports = __webpack_public_path__ + "pc/img/ic_close.97eacd5b.svg";